import {states} from "../../model/States";
import './state-picker.component.scss';
import {IComponentController} from "angular";

export class StatePickerComponent implements IComponentController {

    private allStates = states;
    private searchTerm: string;

    public static instance = {
        template: require('./state-picker.component.html'),
        controller: ['$element', StatePickerComponent],
        bindings: {
            selectedState: '=',
            onEditCallback: '&'
        }
    };

    constructor(private $element) {
    }

    private onEditCallback;

    $postLink(): void {
        this.$element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }

    clearSearchTerm = () => {
        this.searchTerm = '';
    };

    onEdit() {
        this.onEditCallback();
    }
}